<!-- cargoesTitle -->
<cargoes-title *ngIf="parameters.data?.cargoesTitle" [title]="parameters.data?.cargoesTitle.text"></cargoes-title>

<div nz-row class="mt-lg mb-lg mob-mb-md">
  <div nz-col nzXl="24" nzLg="24" nzMd="24" nzSm="24" nzXs="24" class="mb-md">
    <div nz-row>

      <div nz-col nzXl="12" nzLg="12" nzMd="24" nzSm="24" class="mb-md">

        <!-- cargoesFreeText -->
        <cargoes-freetext-component *ngIf="parameters.data?.cargoesFreeText"
          [placeholder]="parameters.data?.cargoesFreeText.placeHolder || ''"
          (onSearch)="onAction(headerEnum.cargoesFreeText_onSearch, $event)" customeWidth="25em">
        </cargoes-freetext-component>

      </div>

      <div nz-col nzXl="12" nzLg="12" nzMd="24" nzSm="24" nzXs="24">
        <div class="text-align-right">

          <!-- button -->
          <button *ngIf="parameters.data?.button" nz-button nzType="default"
            (click)="onAction(headerEnum.button_click)">
            <i nz-icon nzType="{{parameters.data?.button.type}}"
              nzTheme="outline"></i>{{parameters.data?.button.text || '' | translate}}</button>

        </div>
      </div>
    </div>
  </div>
</div>
